<template>
  <div class="map-container">
    <div class="tipInput">
      <el-input
        placeholder="请输入地点"
        v-model="searchKeyword"
        @keyup.enter.native="keyWordSearch"
        class="input-with-select"
        id="tipInput"
      >
        <el-button
          @click="keyWordSearch"
          slot="append"
          icon="el-icon-search"
        ></el-button>
      </el-input>
    </div>
    <div id="container" :style="{ width: '100%', height: '200px' }"></div>
    <div class="addressBox" v-if="showBox">
      <div
        v-for="(item, index) in poiList"
        :key="index"
        @click="addressClick(item)"
        style="cursor: pointer"
      >
        {{ item.name }}
      </div>
    </div>
  </div>
</template>

<script>
import AMapLoader from '@amap/amap-jsapi-loader'
import { mapState } from 'vuex'

window._AMapSecurityConfig = {
  // 设置安全密钥
  securityJsCode: 'abc2c0d0b89e5d39695016bdc1efba38'
}

export default {
  props: {},
  data () {
    return {
      // searchKeyword: "",
      map: null, // 高德地图实例
      AMap: null, // 高德地图全局对象
      placeSearch: null,
      initlatitude: '', // 初始化
      initlongitude: '', // 初始化
      longitudee: '',
      latitudee: '',
      markers: [],
      auto: null,
      poiList: [],
      showBox: false,
      coordinate: '',
      geocoder: null
    }
  },
  computed: {
    searchKeyword: {
      get () {
        return this.$store.state.main.searchKeyword
      },
      set (value) {
        this.$store.commit('main/changeSearchKeyword', value)
      }
    },
    ...mapState('main', ['longitude', 'latitude'])
  },
  mounted () {
    this.initMap()
  },
  methods: {
    initMap () {
      this.$nextTick(async () => {
        // if (navigator.geolocation) {
        //   navigator.geolocation.getCurrentPosition((pos)=>{
        //     console.log("showPositio--n",pos)
        //     if(pos.coords){
        //       this.initlatitude = pos.coords.latitude
        //       this.initlongitude = pos.coords.longitude
        //       this.$store.commit("main/changeLatitudeAndLongitude", {
        //         latitude: pos.coords.latitude,
        //         longitude: pos.coords.longitude
        //       });
        //     }
        //   }, (err)=>{
        //     console.log("showPositio--err",err)
        //   },{
        //     enableHighAccuracy: true,
        //     timeout: 5000,
        //     maximumAge: 0,
        //   });
        // } else {
        //   this.$message.info("当前浏览器不支持自动获取地理定位")
        // }
        // 初始化地图
        console.log('init--ch----0000000', this.searchKeyword, this.longitude, this.latitude)
        AMapLoader.load({
          key: '28c4ffe248c85bf61cb19d91ecda73b6',
          version: '2.0', // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
          plugins: [
            'AMap.Geolocation', // 定位空间，用来获取和展示用户主机所在的经纬度位置
            'AMap.Scale', // 右下角缩略图插件 比例尺
            'AMap.CitySearch',
            'AMap.AutoComplete',
            'AMap.PlaceSearch',
            'AMap.Geocoder'
          ]
        }).then((AMap) => {
          this.AMap = AMap
          const options = this.longitude ? {
            // 设置地图容器id
            // resizeEnable: true,
            viewMode: '3D', // 是否为3D地图模式
            zoom: 11, // 初始化地图级别
            center: [this.longitude, this.latitude], // 初始化中心点坐标
            resizeEnable: true // 调整任意窗口的大小，自适应窗口
          } : {
            // 设置地图容器id
            resizeEnable: true,
            viewMode: '3D', // 是否为3D地图模式
            zoom: 11, // 初始化地图级别
            // center: [], // 初始化中心点坐标
            resizeEnable: true // 调整任意窗口的大小，自适应窗口
          }
          this.map = new AMap.Map('container', options)

          // 创建地理编码实例
          this.geocoder = new AMap.Geocoder({
            // city: "全国",  // 城市，默认：“全国”
          })

          if (this.longitude && this.longitude.length > 0) {
            this.map.setZoomAndCenter(15, [this.longitude, this.latitude])
            this.regeoCode([this.longitude, this.latitude])
            this.clearMarkers()
            this.setMarker(this.longitude, this.latitude)
          }

          this.map.on('click', (ev) => {
            console.log('clic-k--ck', ev)
            this.longitudee = ev.lnglat.getLng()
            this.latitudee = ev.lnglat.getLat()
            this.coordinate = [ev.lnglat.getLng(), ev.lnglat.getLat()]
            //
            this.$store.commit('main/changeLatitudeAndLongitude', {
              latitude: this.latitudee,
              longitude: this.longitudee
            })

            this.clearMarkers()
            this.setMarker(ev.lnglat.getLng(), ev.lnglat.getLat())

            this.regeoCode(this.coordinate)
          })
        })
      })
    },

    setMarker (lng, lat) {
      // 创建一个Marker实例：
      let marker = new AMap.Marker({
        position: new AMap.LngLat(lng, lat), // 经纬度对象
        title: '标记点'
      })
      this.map.add(marker) // 将标记添加到地图中
      this.markers.push(marker) // 存储标记，以备后续使用
    },
    clearMarkers () {
      for (let i = 0; i < this.markers.length; i++) {
        this.markers[i].setMap(null)
      }
      this.markers = []
    },
    // 地图搜索方法
    keyWordSearch () {
      this.placeSearch = new this.AMap.PlaceSearch({
        pageSize: 10,
        pageIndex: 1,
        map: this.map,
        // panel: "panel", // 结果列表将在此容器中进行展示。
        autoFitView: true // 是否自动调整地图视野使绘制的 Marker点都处于视口的可见范围
      })

      this.placeSearch.search(this.searchKeyword, (status, result) => {
        // 搜索成功后的回调函数
        if (status === 'complete' && result.info === 'OK') {
          // 处理搜索结果
          console.log('keyWordSear--ch', result)
          this.poiList = result.poiList.pois
          this.showBox = true
          // // 在地图上标记所有搜索结果的位置
          // result.poiList.pois.forEach((poi) => {
          //   new this.AMap.Marker({
          //     map: this.map,
          //     position: poi.location,
          //   });
          // });
        } else {
          console.error('PlaceSearch failed:', status, result)
        }
      })
    },
    // 点击某个搜索选项
    addressClick (value) {
      console.log('addressCli--ck', value)
      let lnglat = [value.location.lng, value.location.lat]
      this.placeSearch.setCity(value.adcode)
      this.placeSearch.search(value.name)
      this.setMarker(value.location.lng, value.location.lat)
      this.longitudee = value.location.lng
      this.latitudee = value.location.lat
      //
      this.$store.commit('main/changeLatitudeAndLongitude', {
        latitude: this.latitudee,
        longitude: this.longitudee
      })

      this.$store.commit('main/changeSearchKeyword', value.name)

      this.$store.commit('main/changeProvince', {
        provinceName: value?.pname,
        provinceCode: value?.pcode,
        cityName: value?.cityname,
        cityCode: value?.adcode.substring(0, 4) + '00',
        areaName: value?.adname,
        areaCode: value?.adcode
      })
      this.showBox = false
    },
    regeoCode (lnglat) {
      console.log(lnglat)
      this.geocoder.getAddress(lnglat, (status, result) => {
        if (status === 'complete' && result.info === 'OK') {
          var address = result.regeocode.formattedAddress
          this.$store.commit('main/changeProvince', {
            provinceName: result.regeocode.addressComponent?.province,
            provinceCode: result.regeocode.addressComponent?.adcode.substring(0, 2) + '0000',
            cityName: result.regeocode.addressComponent?.city,
            cityCode: result.regeocode.addressComponent?.adcode.substring(0, 4) + '00',
            areaName: result.regeocode.addressComponent?.district,
            areaCode: result.regeocode.addressComponent?.adcode
          })
          this.searchKeyword = address
        } else {
          console.log('根据经纬度查询地址失败')
        }
      })
    }
  },
  beforeDestroy () {
    window._AMapSecurityConfig = {
      // 设置安全密钥
      securityJsCode: '5e8845c918ec7001f3786bd5084600a2'
    }
  }
}
</script>

<style lang="less" scoped>
.map-container {
  position: relative;
  width: 100%;
  overflow: hidden;
  .addressBox {
    position: absolute;
    z-index: 999;
    left: 0;
    top: 36px;

    display: flex;
    flex-direction: column;
    background-color: #fff;
    padding: 5px 10px;

    overflow-y: scroll;
  }
}
/deep/ .search-input {
  width: 260px;
}
</style>
